'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './financialTransaction.routes.js';
import FinTxnViewCtrl from './view/view.controller.js';
import FinTxnSelectCtrl from './select/select.controller.js';
import PaymentModalSvc from './paymentModal/paymentModal.service.js';

export default angular.module('georgeApp.financialTransaction',
  [uiRouter])
  .config(routing)
  .controller('FinTxnViewCtrl', FinTxnViewCtrl)
  .controller('FinTxnSelectCtrl', FinTxnSelectCtrl)
  .factory('PaymentModalSvc', PaymentModalSvc)
  .name;
